export default "__VITE_ASSET__ohUK5Go5__"